/**
 * @fileoverview ZAMLA Report API Service
 * @description API calls for the ZAMLA Report feature
 */

import { apiClient } from '@/services/api/client';

const BASE = '/v1/zamla-report';

export const zamlaReportApi = {
  /**
   * Upload and parse a ZAMLA CSV file
   * @param {File} file - The CSV file to upload
   * @returns {Promise<Object>} Parsed report data (without failed transactions)
   */
  parseCSV: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.postFormData(`${BASE}/parse`, formData);
  },

  /**
   * Get paginated/filtered failed transactions from cached upload
   * @param {string} uploadId - Upload ID from parseCSV response
   * @param {Object} params - Query parameters
   * @param {number} params.page - 1-based page number
   * @param {number} params.page_size - Rows per page
   * @param {string} [params.search] - Global text search
   * @param {string} [params.status] - Filter by status
   * @param {string} [params.crew] - Filter by crew ID
   * @param {string} [params.action] - Filter by action
   * @param {string} [params.reason] - Filter by reason
   * @param {string} [params.timestamp] - Filter by timestamp
   * @param {string} [params.activitiesName] - Filter by activity name
   * @param {string} [params.otherCrew] - Filter by other crew
   * @returns {Promise<Object>} { data: [...], pagination: {...} }
   */
  getFailedTransactions: async (uploadId, params = {}) => {
    const queryParams = { upload_id: uploadId, ...params };
    // Remove empty values
    Object.keys(queryParams).forEach((k) => {
      if (!queryParams[k] && queryParams[k] !== 0) delete queryParams[k];
    });
    return apiClient.get(`${BASE}/failed-transactions`, queryParams);
  },
};
